export const getHoursBetweenDates = ({ startDate, endDate }) => {
  return (
    (new Date(endDate).getTime() - new Date(startDate).getTime()) / 3600000
  );
};
